export interface Point {
  readonly x: number;
  readonly y: number;
}

const format = (value: number): string => value.toFixed(2);

/**
 * Courbe lisse passant exactement par chaque point, au format SVG `d` :
 * une spline de Catmull-Rom convertie en courbes de Bézier cubiques.
 */
export const smoothPath = (points: readonly Point[]): string => {
  const [first] = points;
  if (!first) return '';
  let path = `M${format(first.x)} ${format(first.y)}`;

  for (let index = 0; index < points.length - 1; index += 1) {
    const p0 = points[Math.max(index - 1, 0)] ?? first;
    const p1 = points[index] ?? first;
    const p2 = points[index + 1] ?? p1;
    const p3 = points[Math.min(index + 2, points.length - 1)] ?? p2;
    const c1x = p1.x + (p2.x - p0.x) / 6;
    const c1y = p1.y + (p2.y - p0.y) / 6;
    const c2x = p2.x - (p3.x - p1.x) / 6;
    const c2y = p2.y - (p3.y - p1.y) / 6;
    path += ` C${format(c1x)} ${format(c1y)} ${format(c2x)} ${format(c2y)} ${format(p2.x)} ${format(p2.y)}`;
  }
  return path;
};
